{"rating":"4.9","reviewCount":"140","fetchedAt":"2026-11-04T03:14:53.815Z","source":"place-details"}